export interface RAGChunk {
  chunkId: string;
  sourceTitle: string;
  content: string;
  trustTier: 'TIER_A_OFFICIAL' | 'TIER_B_PRIMARY_PROVIDER' | 'TIER_C_VERIFIED_SECONDARY' | 'TIER_D_EDITORIAL';
  effectiveDate: string;
  verified: boolean;
}

export const MOCK_RAG_CHUNKS: RAGChunk[] = [
  {
    chunkId: 'chunk-001',
    sourceTitle: 'YamooPay Global Salary & Tax Methodology 2026',
    content: 'YamooPay computes net salary using statutory brackets for federal, state, and social contributions. All calculations are executed deterministically without LLM estimation.',
    trustTier: 'TIER_A_OFFICIAL',
    effectiveDate: '2026-01-01',
    verified: true,
  },
  {
    chunkId: 'chunk-002',
    sourceTitle: 'YamooPay Foreign Exchange & Mid-Market Standards',
    content: 'FX rates are sourced from institutional liquidity providers and updated in real-time. Mid-market rates serve as the pristine baseline before provider fee additions.',
    trustTier: 'TIER_A_OFFICIAL',
    effectiveDate: '2026-08-01',
    verified: true,
  },
  {
    chunkId: 'chunk-003',
    sourceTitle: 'YamooPay Compound Interest & Retirement Methodology',
    content: 'Compound interest projections apply standard financial mathematics formulas with configurable inflation adjustment indices.',
    trustTier: 'TIER_A_OFFICIAL',
    effectiveDate: '2026-06-15',
    verified: true,
  },
];

export function retrieveTrustedChunks(query: string): RAGChunk[] {
  const q = query.toLowerCase();
  return MOCK_RAG_CHUNKS.filter(
    (c) => c.content.toLowerCase().includes(q) || c.sourceTitle.toLowerCase().includes(q) || q.length < 3
  );
}
